import * as React from 'react'

import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/Inputs/TextArea'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
}

const TerminationObservation = (props: Props) => {
  const { form } = props

  return (
    <TextArea
      label={i18n.t('employees.termination.termination_specific_reason')}
      placeholder={i18n.t('employees.termination.termination_specific_reason_placeholder')}
      field={form.get('termination_reason')}
    />
  )
}

export default observer(TerminationObservation)
